import { baseApi } from '../baseApi';

import { StockLevel } from './StockLevel';

const slicec = baseApi
  .enhanceEndpoints({
    addTagTypes: ['StockLevels'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getStockLevels: builder.query<StockLevel[], void>({
        keepUnusedDataFor: 60,
        query: () => ({
          url: '/stock-levels',
          method: 'GET',
          headers: {
            'x-api-version': '1.0',
          },
        }),
        providesTags: (result) =>
          result
            ? [
                ...result.map(({ menuItemId }) => ({
                  type: 'StockLevels' as const,
                  id: menuItemId,
                })),
                { type: 'StockLevels', id: 'LIST' },
              ]
            : [{ type: 'StockLevels', id: 'LIST' }],
      }),
    }),
  });

export const { useGetStockLevelsQuery, useLazyGetStockLevelsQuery } = slicec;
